<template>
  <div style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-cyan-9 text-white">
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="text-h6">Dashboard</div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>

         <div class="row">
           <div class="col-12 col-md-3 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-cyan-9  row items-center justify-center">
                  <q-icon class="vertical-middle" name="check_circle" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-cyan-7">
                  <span class="frWidgetText1">Laporan Selesai</span> <br>
                  <span class="frWidgetText2">{{laporan_selesai}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
               <div class="col-4 frWidgetSub1 text-center bg-orange-7  row items-center justify-center">
                  <q-icon name="info" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-orange-4">
                  <span class="frWidgetText1">Laporan Diproses</span> <br>
                  <span class="frWidgetText2">{{laporan_proses}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget ">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-deep-orange-7  row items-center justify-center">
                  <q-icon name="cancel" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-deep-orange-4">
                  <span class="frWidgetText1">Laporan Ditolak</span> <br>
                  <span class="frWidgetText2">{{laporan_dikembalikan}}</span>
                </div>
             </div>
           </div>
           <div class="col-12 col-md-3 frWidget">
             <div class="row shadow-5 frWidgetSub">
                <div class="col-4 frWidgetSub1 text-center bg-blue-9 row items-center justify-center">
                  <q-icon name="library_books" style="font-size:420%; color:white" />
                </div>
                <div class="col-8 frWidgetSub2 bg-blue-7">
                  <span class="frWidgetText1">Artikel Edukasi</span> <br>
                  <span class="frWidgetText2">{{jumlah_artikel}}</span>
                </div>
             </div>
           </div>
         </div>
      </q-card-section>
    </q-card>
    <div class="row">
      <div class="col-12 col-md-6 padding1-5">
        <div class="frameChart shadow-2">
          <div id="anakBar"></div>
        </div>
      </div>
      <div class="col-12 col-md-6 padding1-5">
        <div class="frameChart shadow-2">
          <div id="perempuanPie"></div>
        </div>
      </div>
    </div>




  </div>
</template>

<style>
</style>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'

exportingInit(Highcharts)
export default {
  name: 'HomePage',
  data() {
    return {
        laporan_selesai : '',
        laporan_proses : '',
        laporan_dikembalikan : '',
        jumlah_artikel : '',
    }
  },
  methods: {

    getJumlahSelesai : function(){
        fetch(this.$store.state.url.URL_BERANDA + "selesai", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.laporan_selesai = res_data.data[0].laporan_selesai;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahProses : function(){
        fetch(this.$store.state.url.URL_BERANDA + "proses", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.laporan_proses = res_data.data[0].laporan_proses;
              // console.log(laporan_proses);
        });
      },

      getJumlahArtikel : function(){
        fetch(this.$store.state.url.URL_BERANDA + "artikel", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_artikel = res_data.data[0].jumlah_artikel;
        });
      },

      getJumlahTolak : function(){
        fetch(this.$store.state.url.URL_BERANDA + "dikembalikan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.laporan_dikembalikan = res_data.data[0].laporan_dikembalikan;
        });
      },

      getPerempuanPie: function() {
        fetch(this.$store.state.url.URL_BERANDA + "perempuan", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
        })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
            this.perempuan = res_data.data;
             console.log(this.perempuan);

             var perempuan = [];
             var hasil = this.perempuan;

             for(var i in hasil) {
               perempuan.push({"name" : hasil[i].nama_jenis, "y" : hasil[i].jumlah});

             }

             console.log(perempuan);


             this.perempuanPie(perempuan);
          });
    },
    
    getAnakBar: function() {
        fetch(this.$store.state.url.URL_BERANDA + "anak", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
        })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
            this.anak = res_data.data;
             console.log(this.anak);

             var anak = [];
             var hasil = this.anak;

             for(var i in hasil) {
               anak.push({"name" : hasil[i].nama_jenis, "y" : hasil[i].jumlah});

             }

             console.log(anak);


             this.anakBar(anak);
          });
    },
  
    anakBar : function(anak){
      Highcharts.chart('anakBar', {
          chart: {
              type: 'column'
          },
          title: {
              align: 'center',
              text: 'Kasus Kekerasan Terhadap Anak'
          },
          subtitle: {
              align: 'center',
              text: 'Sahabat Perempuan & Anak Konawe Selatan'
          },
          accessibility: {
              announceNewData: {
                  enabled: true
              }
          },
          xAxis: {
              type: 'category'
          },
          yAxis: {
              title: {
                  text: 'Jumlah Kasus'
              }

          },
          legend: {
              enabled: false
          },
          plotOptions: {
              series: {
                  borderWidth: 0,
                  dataLabels: {
                      enabled: true,
                      format: '{point.y:.0f}'
                  }
              }
          },

          tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b> Kasus<br/>'
          },

          series: [
              {
                  name: 'Jumlah Kasus',
                  colorByPoint: true,
                  data: anak
              }
          ],
          drilldown: {
              breadcrumbs: {
                  position: {
                      align: 'right'
                  }
              },
              series: [
                  {
                      name: 'Jumlah Kasus',
                      data: anak
                  }
              ]
          }
      });
    },

    perempuanPie : function(perempuan) {
      // Create the chart
      Highcharts.chart('perempuanPie', {
          chart: {
              type: 'pie'
          },
          title: {
              text: 'Kasus Kekerasan Terhadap Perempuan',
              align: 'center'
          },
          subtitle: {
              text: 'Sahabat Perempuan & Anak Konawe Selatan',
              align: 'center'
          },

          accessibility: {
              announceNewData: {
                  enabled: true
              },
              point: {
                  valueSuffix: '%'
              }
          },

          plotOptions: {
              series: {
                  borderRadius: 5,
                  dataLabels: [{
                      enabled: true,
                      distance: 15,
                      format: '{point.name}'
                  }, {
                      enabled: true,
                      distance: '-30%',
                      filter: {
                          property: 'percentage',
                          operator: '>',
                          value: 5
                      },
                      format: '{point.y:.0f}',
                      style: {
                          fontSize: '0.9em',
                          textOutline: 'none'
                      }
                  }]
              }
          },

          tooltip: {
              headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b> Kasus<br/>'
          },

          series: [
              {
                  name: 'Jumlah Kasus',
                  colorByPoint: true,
                  data: perempuan
              }
          ],
          drilldown: {
              series: [
                  {
                      name: 'Jumlah Kasus',
                      data: perempuan
                  }
              ]
          }
      });
    },

  },
  mounted () {
    this.getAnakBar();
    this.getPerempuanPie();
    this.getJumlahProses();
    this.getJumlahSelesai();
    this.getJumlahTolak();
    this.getJumlahArtikel();
  },
}
</script>
